const {StatusCodes, getReasonPhrase} = require('http-status-codes');

const {track} = require('@stubhub/tracking-utils');

const MAX_USER_ERROR = 499;
const MAX_PLATFORM_ERROR = 599;

function logToGTM({code, name, details, related_url}) {
  const inRange = (code, min, max) => code >= min && code <= max;
  let eventType = 'error_network';
  if (Number.isInteger(code)) {
    if (inRange(code, StatusCodes.BAD_REQUEST, MAX_USER_ERROR)) {
      eventType = 'error_user';
    } else if (inRange(code, StatusCodes.INTERNAL_SERVER_ERROR, MAX_PLATFORM_ERROR)) {
      eventType = 'error_platform';
    }
  }

  track('error', {
    event: eventType,
    code: code || null,
    error_name: name || null,
    details: details || null,
    related_url: related_url || null,
  });
}

function isNotEmptySring(error) {
  if (typeof error === 'string' && error.length > 0) {
    return error;
  }

  return null;
}

exports.logGTMError = function ({code, name, details}, apiRequestOptions) {
  if (typeof window !== 'undefined') {
    const url = apiRequestOptions && apiRequestOptions.uri;
    logToGTM({code, name, details, related_url: url});
  }
};

exports.logGTMResponse = function (resp, apiRequestOptions) {
  if (typeof window !== 'undefined') {
    const {status, statusText, statusCode, body, url: responseUrl} = resp.clone(); // Copy to avoid losing the original body stream
    const url = responseUrl || (apiRequestOptions && apiRequestOptions.uri);
    let name = null;
    try {
      name = (isNotEmptySring(statusText) && statusText) || (statusCode && getReasonPhrase(statusCode) || (status && getReasonPhrase(status)));
    } catch {
      // Do nothing as the error is unknown
    }

    if (body) {
      return new Response(body)
        .text()
        .then((data) => {
          try {
            const json = JSON.parse(data) || {};
            const error = json.error && typeof json.error === 'object' ? json.error : json;
            let errorName;
            try {
              errorName =
                error.code ||
                (isNotEmptySring(error.error) && error.error) ||
                name ||
                (status && getReasonPhrase(status));
            } catch {
              // Do nothing as the error is unknown
            }
            const details = error.description || error.message || data;

            return logToGTM({code: status, name: errorName, details, related_url: url});
          } catch (e) {
            return logToGTM({code: status, name, details: data, related_url: url});
          }
        })
        .catch(() => {
          return logToGTM({code: status, name, related_url: url});
        });
    }

    return logToGTM({code: status, name, related_url: url});
  }
};
